import _ from 'lodash';
const commonCreditOnly = {
  heading: 'Build credit with debit',
  title: 'Credit Building',
  description: 'Build credit without earning reward points',
  features: ['Build your credit history automatically with your Extra Debit purchases', 'Gain full understanding of your credit score with the intuitive Extra Credit Monitoring tool', 'Prevent overdafts and add an extra layer of financial security to your bank account with Spend Power'],
  icon: '/plan-credit.svg',
  mobile: {
    title: 'Extra Credit Building',
    features: [0, 1]
  },
  displayOnlyFullPrice: [null, null]
};
const commonCombined = {
  heading: 'The ultimate extra experience',
  title: 'Credit Building + Rewards',
  description: 'Earn reward points for every swipe and get access to our exclusive reward store',
  features: ['Access to all perks of Extra Credit Building including monthly spend reporting and intuitive score monitoring', 'Access to all perks of Extra Rewards including unlimited points earning and access to the members-only Extra Shops', 'Prevent overdafts and add an extra layer of financial security to your bank account with Spend Power'],
  icon: '/plan-combined.svg',
  mobile: {
    title: 'Rewards + Credit Building',
    features: [0, 1, 2, 3]
  },
  most_popular: true,
  displayOnlyFullPrice: [null, null]
};
const allPlans = [
// leaving out rewards only plans, the funnel isn't set up to support them
{
  ...commonCreditOnly,
  name: 'credit_only',
  price: [6, 60]
}, {
  ...commonCombined,
  name: 'combined',
  price: [10, 96]
}, {
  ...commonCreditOnly,
  name: 'credit_only_free',
  price: [0, 0]
}, {
  ...commonCombined,
  name: 'combined_free',
  price: [0, 0]
}, {
  ...commonCreditOnly,
  name: 'credit_only_test_set_1',
  price: [10, 96]
}, {
  ...commonCombined,
  name: 'combined_test_set_1',
  price: [15, 120]
}, {
  ...commonCreditOnly,
  name: 'credit_only_test_set_2',
  price: [8, 84]
}, {
  ...commonCombined,
  name: 'combined_test_set_2',
  price: [12, 108]
}, {
  ...commonCreditOnly,
  name: 'credit_only_test_set_3',
  price: [16, 149],
  displayOnlyFullPrice: [null, 200]
}, {
  ...commonCombined,
  name: 'combined_test_set_3',
  price: [22, 199],
  displayOnlyFullPrice: [null, 265]
}, {
  ...commonCreditOnly,
  name: 'credit_only_test_set_4',
  price: [20, 149],
  displayOnlyFullPrice: [null, 240]
}, {
  ...commonCombined,
  name: 'combined_test_set_4',
  price: [25, 199],
  displayOnlyFullPrice: [null, 300]
}];
const activePlans = allPlans.filter(plan => ['credit_only_test_set_4', 'combined_test_set_4'].includes(plan.name));
// thanks @jsartelle for the example :) -@roland
const cohorts = {
  'ndr-promo-jun-2023': [{
    name: 'credit_only_ndr_promo',
    title: 'Credit Building (NDR Special)',
    price: [12, 90],
    priceDiscountedFrom: [20, 149],
    displayOnlyFullPrice: [null, 144]
  }, {
    name: 'combined_ndr_promo',
    title: 'Credit Building + Rewards (NDR Special)',
    price: [15, 120],
    priceDiscountedFrom: [25, 199],
    displayOnlyFullPrice: [null, 180]
  }]
};
export default function getPlans(cohort = null) {
  let plans = _.cloneDeep(activePlans);
  if (cohort && cohorts[cohort]) {
    // apply the cohort-specific overrides
    plans = plans.map((plan, index) => Object.assign(plan, cohorts[cohort][index]));
  }
  // calculate discount percentages
  plans = plans.map(plan => {
    plan.discount = plan.displayOnlyFullPrice.map((fullPrice, index) => {
      const discount = 100 - Math.round(plan.price[index] / fullPrice * 100);
      return Number.isFinite(discount) ? discount : null;
    });
    return plan;
  });
  return plans;
}
export function getPlanByName(planName) {
  return allPlans.find(plan => plan.name === planName);
}